import { Typography as TypoGraphyComp } from "@mui/material";
import TypographyStyles from "./Typography.module.scss";
import { CustomTypographyProps } from "../../common/types";

export default function Typography({
  fontSize = 14,
  fontFamily = "Google Sans",
  lineHeight = "15px",
  style,
  className,
  children,
  fontWeight = 400,
  color,
  fontStyle,
  ellipsis,
  ...rest
}: CustomTypographyProps) {
  return (
    <TypoGraphyComp
      fontSize={fontSize}
      fontFamily={fontFamily}
      lineHeight={lineHeight}
      style={style}
      className={`${className} ${ellipsis ? TypographyStyles.ellipsis : ""}`}
      fontWeight={fontWeight}
      color={color}
      fontStyle={fontStyle}
      sx={{ textTransform: "none" }}
      {...rest}
    >
      {children}
    </TypoGraphyComp>
  );
}
